import Emitter from "es6-event-emitter";

import language from "./../dictionary";

import { generateCoverURL, reflect } from "./../utilities/utils";

import APIManager from "./../utilities/apimanager";

import {
  CLICKED_MAIN_HOME,
  CLICKED_READ_HOME,
} from "./../analytics/analyticsevents";

import {
  IFRAME_KIOSQUE_MOBILE,
  IFRAME_KIOSQUE_TOP,
  IFRAME_KIOSQUE_BOTTOM,
  IFRAME_KIOSQUE_ARCHIVE,
  IFRAME_KIOSQUE_ARCHIVE_BOTTOM,
} from "./../utilities/redirectorKeys";

/**
 * Contstructs the Kiosque view
 */
export default class CommonKiosque extends Emitter {
  appState = null;
  DOMContainer = null;
  DOMContent = null;
  options = null;
  _rerunSetMainNewsPaper = null;

  mainContentPackageId = null;

  constructor(appState, DOMContainer, dustFile, options) {
    super();
    this.appState = appState;
    this.DOMContainer = DOMContainer;
    this.options = options;
    this.render(dustFile);
  }

  createContext() {
    const promise = new Promise((resolve) => {
      //create context
      const context = {};
      context.i18n = language;

      if (this.appState.isDesktop) {
        const promises = [
          APIManager.getRedirectorUrl(
            IFRAME_KIOSQUE_TOP,
            this.appState.buildVersion,
            this.appState.userId,
            this.appState.downloadToken
          ),
          APIManager.getRedirectorUrl(
            IFRAME_KIOSQUE_BOTTOM,
            this.appState.buildVersion,
            this.appState.userId,
            this.appState.downloadToken
          ),
          APIManager.getRedirectorUrl(
            IFRAME_KIOSQUE_ARCHIVE,
            this.appState.buildVersion,
            this.appState.userId,
            this.appState.downloadToken
          ),
          APIManager.getRedirectorUrl(
            IFRAME_KIOSQUE_ARCHIVE_BOTTOM,
            this.appState.buildVersion,
            this.appState.userId,
            this.appState.downloadToken
          ),
        ];
        Promise.all(promises.map(reflect)).then((result) => {
          if (result[0].status === "resolved") {
            context.iFrameTopURL = result[0].v;
          }
          if (result[1].status === "resolved") {
            context.iFrameBottomURL = result[1].v;
          }
          if (result[2].status === "resolved") {
            context.iframeArchiveURL = result[2].v;
          }
          if (result[3].status === "resolved") {
            context.iframeArchiveBottomURL = result[3].v;
          }
          resolve(context);
        });
      } else {
        APIManager.getRedirectorUrl(
          IFRAME_KIOSQUE_MOBILE,
          this.appState.buildVersion,
          this.appState.userId,
          this.appState.downloadToken
        )
          .then((result) => {
            context.iframebanner_source = result;
          })
          .catch(() => {
            context.iframebanner_source = null;
          })
          .then(() => {
            resolve(context);
          });
      }
    });
    return promise;
  }

  render(dustFile) {
    if (this.DOMContainer) {
      this.createContext().then((context) => {
        Dust.render(dustFile, context, (err, result) => {
          this.DOMContainer.innerHTML = result;
          this.DOMContent = this.DOMContainer.querySelector(".kiosque");
          this.attatchCommonClickHandlers();
          this.attatchClickHandlers();
          this.renderDone();
          // setMainNewsPaper can run before rendering ends
          if (this._rerunSetMainNewsPaper) {
            setTimeout(() => {
              this.setMainNewsPaper(this._rerunSetMainNewsPaper);
            }, 0);
          }
        });
      });
    }
  }

  renderDone() {}

  setContentPackages(contentPackages) {
    if (contentPackages) {
      this.setMainNewsPaper(contentPackages[0]);
      this.setArchive(contentPackages.slice(1, this.options.archiveLength - 1));
    }
  }

  attatchCommonClickHandlers() {
    const mainImage = this.DOMContainer.querySelector(
      ".main-paper-container .main-image-wrapper img.main-image"
    );
    if (mainImage) {
      mainImage.addEventListener("click", () => {
        this.appState.triggerEvent(CLICKED_MAIN_HOME);
        this.mainClicked();
      });
    }

    const mainButton = this.DOMContainer.querySelector(
      ".main-paper-container .main-button-container .main-button-wrapper"
    );
    if (mainButton) {
      mainButton.addEventListener("click", () => {
        this.appState.triggerEvent(CLICKED_READ_HOME);
        this.mainClicked();
      });
    }
  }

  mainClicked() {
    const publicationId = undefined;
    const contentPackageId = this.mainContentPackageId;
    const publicationData = {
      contentPackageId,
      publicationId,
    };
    this.trigger("kiosque:onPublicationClicked", publicationData);
  }

  setMainNewsPaper(contentPackage) {
    if (this.DOMContent) {
      if (contentPackage) {
        this.mainContentPackageId = contentPackage.ContentPackageId;
        const mainImage = this.DOMContainer.querySelector(
          ".main-paper-container .main-image-wrapper img.main-image"
        );
        if (mainImage) {
          mainImage.setAttribute(
            "src",
            generateCoverURL(
              this.mainContentPackageId,
              this.options.sizes.M,
              contentPackage.ThumbnailId,
              contentPackage.Version
            )
          );
          mainImage.classList.remove("hidden");
          this._rerunSetMainNewsPaper = null;
        } else {
          this._rerunSetMainNewsPaper = contentPackage;
        }
        const label = this.DOMContainer.querySelector(
          ".main-paper-container .main-label"
        );
        if (label) {
          label.innerHTML = contentPackage.label;
        }
      }
    } else {
      setTimeout(() => {
        this.setMainNewsPaper(contentPackage);
      }, 100);
    }
  }

  onPublicationClick(e) {
    const publicationId = e.currentTarget.getAttribute("data-publicationid");
    const contentPackageId = e.currentTarget.getAttribute(
      "data-contentpackageid"
    );
    const publicationData = {
      contentPackageId,
      publicationId,
    };
    this.trigger("kiosque:onPublicationClicked", publicationData);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/kiosque.js